// Lightweight Supabase Storage image transform helper.
// Converts /storage/v1/object/public/... URLs to /storage/v1/render/image/public/...
// with width/quality params. Non-Supabase URLs are returned unchanged.

export function optimizeImg(url: string | null | undefined, opts: { width?: number; quality?: number } = {}): string {
  if (!url) return "";
  try {
    const u = new URL(url);
    if (!u.pathname.includes("/storage/v1/object/public/")) return url;
    u.pathname = u.pathname.replace("/storage/v1/object/public/", "/storage/v1/render/image/public/");
    if (opts.width) u.searchParams.set("width", String(opts.width));
    u.searchParams.set("quality", String(opts.quality ?? 75));
    u.searchParams.set("resize", "contain");
    return u.toString();
  } catch {
    return url;
  }
}

// srcset builder for responsive images served via Supabase render endpoint.
export function srcSet(url: string | null | undefined, widths: number[], quality = 75): string {
  if (!url) return "";
  return widths.map((w) => `${optimizeImg(url, { width: w, quality })} ${w}w`).join(", ");
}
